//Mock data for Course Dashboard Service
export function getMockData(type: string) {
  switch(type) {
    case 'students-mock':
      return  [
          {
            '_id': '1',
            'email': 'john@gmail.com',
            'name': 'John von Neumann',
            'firstname': 'John',
            'lastname': 'von Neumann'
          },
          {
            '_id': '2',
            'email': 'enrico@gmail.com',
            'name': 'Enrico Fermi',
            'firstname': 'Enrico',
            'lastname': 'Fermi',
          },
          {
            '_id': '3',
            'email': 'richard@gmail.com',
            'firstname': 'Richard',
            'lastname': 'Feynman',
            'name': 'Richard Feynman'
          },
          {
            '_id': '4',
            'email': 'albert@gmail.com',
            'firstname': 'Albert',
            'lastname': 'Einstein',
            'name': 'Albert Einstein'
          },
          {
            '_id': '5',
            'email': 'henri@gmail.com',
            'firstname': 'Henri',
            'lastname': 'Poincare',
            'name': 'Henri Poincare'
          },
          {
            '_id': '6',
            'email': 'marie@gmail.com',
            'firstname': 'Marie',
            'lastname': 'Curie',
            'name': 'Marie Curie'
          },
          {
            '_id': '7',
            'email': 'nicolaus@gmail.com',
            'firstname': 'Nicolaus',
            'lastname': 'Copernicus',
            'name': 'Nicolaus Copernicus'
          },
          {
            '_id': '8',
            'email': 'isaac@gmail.com',
            'firstname': 'Isaac',
            'lastname': 'Newtown',
            'name': 'Isaac Newtown'
          },
          {
            '_id': '9',
            'email': 'leonard@gmail.com',
            'firstname': 'Leonard',
            'lastname': 'Euler',
            'name': 'Leonard Euler'
          },
          {
            '_id': '10',
            'email': 'galileo@gmail.com',
            'firstname': 'Galileo',
            'lastname': 'Galilei',
            'name': 'Galileo Galilei'
          },
          {
            '_id': '11',
            'email': 'johannes@gmail.com',
            'firstname': 'Johannes',
            'lastname': 'Kepler',
            'name': 'Johannes Kepler'
          },
          {
            '_id': '12',
            'email': 'nicola@gmail.com',
            'firstname': 'Nicola',
            'lastname': 'Tesla',
            'name': 'Nicola Tesla'
          },
          {
            '_id': '13',
            'email': 'niels@gmail.com',
            'firstname': 'Niels',
            'lastname': 'Bohr',
            'name': 'Niels Bohr'
          },
          {
            '_id': '14',
            'email': 'Werner@gmail.com',
            'firstname': 'Werner',
            'lastname': 'Heisenberg',
            'name': 'Werner Heisenberg'
          },
          {
            '_id': '15',
            'email': 'Hermann@gmail.com',
            'firstname': 'Hermann',
            'lastname': 'Weyl',
            'name': 'Hermann Weyl'
          },
          {
            '_id': '16',
            'email': 'gottfried@gmail.com',
            'firstname': 'Gottfried Wilhelm',
            'lastname': 'von Leibniz',
            'name': 'Gottfried Wilhelm von Leibniz'
          },
          {
            '_id': '17',
            'email': 'carl@gmail.com',
            'firstname': 'Carl Friedrich ',
            'lastname': 'Gauss',
            'name': 'Carl Friedrich Gauss'
          }
        ]
      
    case 'engagement-mock': {
      const engagement = {
        percent: 78,
        disengaged: [
          {
            '_id': '4',
            'email': 'albert@gmail.com',
            'name': 'Albert Einstein'
          },
          {
            '_id': '6',
            'email': 'marie@gmail.com',
            'name': 'Marie Curie'
          },
        ],
        struggling: [
          {
            '_id': '5',
            'email': 'henri@gmail.com',
            'name': 'Henri Poincare'
          },
          {
            '_id': '7',
            'email': 'nicolaus@gmail.com',
            'name': 'Nicolaus Copernicus'
          },
        ],
        engaged: [
          {
            '_id': '11',
            'email': 'Niels@gmail.com',
            'name': 'Niels Bohr'
          },
          {
            '_id': '8',
            'email': 'isaac@gmail.com',
            'name': 'Isaac Newtown'
          },
          {
            '_id': '9',
            'email': 'leonard@gmail.com',
            'name': 'Leonard Euler'
          },
          {
            '_id': '1',
            'email': 'john@gmail.com',
            'name': 'John von Neumann'
          },
          {
            '_id': '2',
            'email': 'enrico@gmail.com',
            'name': 'Enrico Fermi'
          },
          {
            '_id': '10',
            'email': 'galileo@gmail.com',
            'name': 'Galileo Galilei'
          },
          {
            '_id': '12',
            'email': 'nicola@gmail.com',
            'name': 'Nicola Tesla'
          },
          {
            '_id': '13',
            'email': 'niels@gmail.com',
            'name': 'Niels Bohr'
          },
          {
            '_id': '15',
            'email': 'Hermann@gmail.com',
            'name': 'Hermann Weyl'
          },
          {
            '_id': '16',
            'email': 'gottfried@gmail.com',
            'name': 'Gottfried Wilhelm von Leibniz'
          },
          {
            '_id': '17',
            'email': 'carl@gmail.com',
            'name': 'Carl Friedrich Gauss'
          },
          {
            '_id': '3',
            'email': 'richard@gmail.com',
            'name': 'Richard Feynman'
          },
        ]
      };
      return engagement;
    }

    case 'average-score-mock':
      return fetch('/average.json').then(res => res.json());
     
    case 'summary-logged-in-mock':
      return {
          'count': 16,
          'total': 17,
          'trend': '+',
          'trendmins': '-',
          'prior': 15,
          'priormins': 179,
          'mins': 141
      };

    case 'summary-alerts-mock':
      return {
        'data': {
          'count': 3,
          'prior': 2,
          'trend': '+'
        }
      };

    case 'quiz-schedule-mock':
      return {
        'calendar_data': [
          {
            date: new Date().setDate(new Date().getDate() - new Date().getDay() -2),
            status: 'closed', index: 0,
            lessonName: 'L2 - The Industrial Revolution',
            quizName: 'Lesson Quiz'
          },
          {
            date: new Date().setDate(new Date().getDate() - new Date().getDay() - 6),
            status: 'open', index: 0,
            lessonName: 'L2 - The Industrial Revolution',
            quizName: 'Lesson Quiz'
          },
          {
            date: new Date().setDate(new Date().getDate() - new Date().getDay() + 8),
            lessonName: 'L3 - The Post Industrial Era',
            quizName: 'Learning Quiz', index: 0,
            status: 'open'
          },
          {
            date: new Date().setDate(new Date().getDate() - new Date().getDay() + 5),
            lessonName: 'L3 - The Post Industrial Era',
            quizName: 'Lesson Quiz', index: 0,
            status: 'scheduled'
          }
        ],
      };
      
    case 'activities-mock':
      return [
          {'lessonName': 'L1: Scheduled Lesson', 'type': 'assessment', 'scoring_type': 'auto', 'lesson_num': 1, 'lesson': {'id': '5b610ef9dda2340c06f55441', 'title': 'Scheduled Lesson'}, 'close_date': '2017-03-29T04:00:00.000000Z', 'number_of_opens': 0, '_id': '58d2c4bcdda23417d6610891', 'display_score': false, 'activity_id': '58d2c4bcdda23417d6610891', 'submission_attempts': 1, 'display_correct_answers_inline': false, 'confidence': false, 'open_date': '2017-03-22T18:38:00.000000Z', 'instructor_title': null, 'answers_reveal': false, 'link': '#/58b83202dda2342dfcd264d2/5b610ef9dda2340c06f55441/5b522948dda23428ec5057d4', 'title': 'Some quiz', 'display_correct_answers': false, 'max_score': 1, 'graded': false, 'rollup_id': 1},
          {'lessonName': 'L1: Scheduled Lesson', 'type': 'board', 'scoring_type': '-', 'lesson_num': 1, 'lesson': {'id': '5b610ef9dda2340c06f55441', 'title': 'Scheduled Lesson'}, 'title': 'board', 'instructor_title': null, 'id': '5b3bce33dda234166f34ac3c', 'link': '#/58b83202dda2342dfcd264d2/5b610ef9dda2340c06f55441/5b05950fdda2340adb11a6a4', 'graded': false, 'max_score': 1,'rollup_id': 2},
          {'lessonName': 'L1: Scheduled Lesson', 'type': 'assessment', 'scoring_type': 'auto', 'lesson_num': 1, 'lesson': {'id': '5b610ef9dda2340c06f55441', 'title': 'Scheduled Lesson'}, 'time_limit': 1800, 'close_date': '2018-11-27T05:00:00.000000Z', 'number_of_opens': 0, '_id': '5b5465d4dda2340c1f0fad92', 'display_score': true, 'activity_id': '5b5465d4dda2340c1f0fad92', 'submission_attempts': 100, 'display_correct_answers_inline': false, 'confidence': false, 'display_correct_answers_maxattempts': false, 'open_date': '2017-09-02T21:03:00.000000Z', 'instructor_title': null, 'answers_reveal': true, 'link': '#/58b83202dda2342dfcd264d2/5b610ef9dda2340c06f55441/5b5465d5dda2340c1f0fad93', 'title': 'please no item pool id 7', 'display_correct_answers': false, 'max_score': 1, 'graded': true, 'rollup_id': 1},
          {'lessonName': 'L1: Scheduled Lesson', 'type': 'lti', 'scoring_type': '-', 'lesson_num': 1, 'lesson': {'id': '5b610ef9dda2340c06f55441', 'title': 'Scheduled Lesson'}, 'max_score': 1, 'graded': true, 'LTI_origin': '5b031ac4dda2340a8053a779', 'id': '5b3bd486dda23417a11d5e9b', 'link': '#/58b83202dda2342dfcd264d2/5b610ef9dda2340c06f55441/5aa157eadda2340ac0710de1', 'title': 'You are a tool!', 'instructor_title': 'CASLS LTI','rollup_id': 2},
          {'lessonName': 'L2: Test Lesson', 'type': 'assessment', 'scoring_type': 'auto', 'lesson_num': 2, 'lesson': {'id': '5b610f9ddda2340c06f5544a', 'title': 'Test Lesson'}, 'time_limit': 0, 'close_date': '2018-11-27T05:00:00.000000Z', 'number_of_opens': 0, '_id': '5b50e174dda2342dbdcb4c0b', 'id': '5b50e174dda2342dbdcb4c0b', 'display_score': true, 'activity_id': '58bdb334dda2345660bd9806', 'submission_attempts': 100, 'display_correct_answers_inline': false, 'confidence': false, 'display_correct_answers_maxattempts': false, 'open_date': '2017-09-02T21:03:00.000000Z', 'instructor_title': null, 'answers_reveal': true, 'link': '#/58b83202dda2342dfcd264d2/5b610f9ddda2340c06f5544a/5b50e175dda2342dbdcb4c0c', 'title': 'Abracadabra Open Sesame Here is a proof of concept of what could be going on', 'display_correct_answers': false, 'max_score': 1, 'graded': true,'rollup_id': 1},
          {'lessonName': 'L2: Test Lesson', 'type': 'board', 'scoring_type': '-', 'lesson_num': 2, 'lesson': {'id': '5b610f9ddda2340c06f5544a', 'title': 'Test Lesson'}, 'close_date': '2017-10-31T04:00:00.000Z', 'closed': true, 'id': '5b311c1edda23417f97ddee0', 'link': '#/58b83202dda2342dfcd264d2/5b610f9ddda2340c06f5544a/5b311c21dda23417f97ddee1', 'title': 'Disqus Upsadaisy', 'instructor_title': null, 'max_score': 1,'rollup_id': 2},
          {'lessonName': 'L3: Published Lesson', 'type': 'board', 'scoring_type': '-', 'lesson_num': 3, 'lesson': {'id': '5b610bf2dda2340c06f55438', 'title': 'Published Lesson'}, 'close_date': '2018-07-20T15:44:00.000Z', 'max_score': '10', 'id': '5b52035ddda23415d3e89f37', 'link': '#/58b83202dda2342dfcd264d2/5b610bf2dda2340c06f55438/5b52035edda23415d3e89f38', 'title': '', 'instructor_title': 'All A-Board Instructor Only', 'closed': true, 'graded': true,'rollup_id': 2},
          {'lessonName': 'L3: Published Lesson', 'type': 'assessment', 'scoring_type': 'auto', 'lesson_num': 3, 'lesson': {'id': '5b610bf2dda2340c06f55438', 'title': 'Published Lesson'}, 'confidence': false, 'time_limit': 0, 'close_date': null, 'number_of_opens': 0, 'open_date': '2018-02-21T15:52:00.000000Z', 'instructor_title': null, '_id': '5a8d9b1fdda2340c51c82c79', 'display_score': false, 'activity_id': '5a8d9b1fdda2340c51c82c79', 'answers_reveal': false, 'submission_attempts': 0, 'link': '#/58b83202dda2342dfcd264d2/5b610bf2dda2340c06f55438/59dcecb6dda2340c82568aac', 'title': '', 'display_correct_answers': false, 'max_score': 1, 'graded': true, 'display_correct_answers_inline': false,'rollup_id': 1},
      ];
    
    case 'most-recently-closed-mock':
      return {
        data: {lesson: 1}
      };
  }
}
